import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Dialog, Typography, Box, Button } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import DOMPurify from 'dompurify'

import { LoadingButton } from 'components'

import theme from 'theme'

const ConfirmationDialog = ({
  open,
  setOpen,
  message,
  subMessage,
  alert,
  alertColor = 'error',
  buttonText = 'concordo',
  actionAcceptButton,
  cancelButtonText = 'cancelar',
  hideCancelButton = false,
  ...rest
}) => {
  const [loading, setLoading] = useState(false)

  const handleAccept = async () => {
    setLoading(true)
    actionAcceptButton()
  }

  const handleClose = (_, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false)
    }
  }

  useEffect(() => {
    if (loading && !open) {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        px={4}
        pt={6}
        pb={4}
        gridGap={theme.spacing(2)}
      >
        <Typography variant="h4" align="center">
          {message}
        </Typography>
        {subMessage && (
          <Typography
            variant="h6"
            align="center"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subMessage) }}
          />
        )}
        {alert && Array.isArray(alert)
          ? alert.map((alertLine, index) => (
              <Alert key={index} severity={alertColor}>
                <Typography variant="body2">{alertLine}</Typography>
              </Alert>
            ))
          : alert && (
              <Alert severity={alertColor}>
                <Typography variant="body2">{alert}</Typography>
              </Alert>
            )}
      </Box>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        mb={2}
      >
        {!hideCancelButton && (
          <Box mr={2}>
            <Button
              disabled={loading}
              onClick={handleClose}
              variant="outlined"
              disableElevation
            >
              {cancelButtonText}
            </Button>
          </Box>
        )}
        <LoadingButton
          loading={loading}
          text={buttonText}
          alert={!!alert && alertColor === 'error'}
          autoFocus
          onClick={handleAccept}
          disableElevation
          {...rest}
        />
      </Box>
    </Dialog>
  )
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  message: PropTypes.string,
  subMessage: PropTypes.string,
  alert: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  buttonText: PropTypes.string,
  actionAcceptButton: PropTypes.func,
  cancelButtonText: PropTypes.string,
  alertColor: PropTypes.string,
}

export default ConfirmationDialog
